


// todo 放到uiconfig中，要真正实现
const state = {
  // theme: variables.theme,
  showSettings: true,
  tagsView: true,
  fixedHeader: false,
  sidebarLogo: true,
  breadcrumbShow: false
}

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  }
}

const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

